import React from "react";

/** Sold out = no stock, not a preorder. */
export const isSoldOut = (article) =>
  !!article && Number(article.quantity_stock ?? 0) <= 0 && article.availability_type !== "preorder";

/** Rotated red "ESAURITO" stamp centred over a `relative` image container. */
export const SoldOutStamp = ({ articleId, size = "md" }) => {
  const text = size === "lg" ? "text-3xl px-6 py-2 border-4" : size === "sm" ? "text-xs px-2 py-0.5 border-2" : "text-lg px-4 py-1 border-[3px]";
  return (
    <span
      className="absolute inset-0 z-10 flex items-center justify-center pointer-events-none"
      data-testid={`sold-out-stamp-${articleId}`}
    >
      <span
        className={`-rotate-12 bg-red-600/90 text-white font-black uppercase tracking-[0.2em] border-red-400 shadow-[0_6px_24px_rgba(0,0,0,0.6)] ${text}`}
      >
        Esaurito
      </span>
    </span>
  );
};

/** Tailwind classes to grey out a sold-out image. */
export const SOLD_OUT_IMG = "grayscale opacity-50 contrast-90";
